// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-L":"L_vanlife-roadtrips-L__pUVec"};